// extracted by mini-css-extract-plugin
module.exports = {"LanguageTranslations":"Translations_LanguageTranslations__2KzYl","TranslationsHolder":"Translations_TranslationsHolder__2CCLz","InputHolder":"Translations_InputHolder__cGU3o"};